/* ============================================================
   VYARA® — PRODUCTS JS  (assets/vyara-products.js)
   Loaded only on collection pages via sections/vyara-collection.liquid
   ============================================================ */

(function () {
  'use strict';

  /* ── SIDEBAR FILTER CHECKBOXES ── */
  document.querySelectorAll('.vyara-sb-option').forEach(function (el) {
    el.addEventListener('click', function () {
      this.classList.toggle('is-active');
      var chk = this.querySelector('.vyara-sb-option__check');
      if (chk) chk.textContent = this.classList.contains('is-active') ? '✓' : '';
    });
  });

  document.querySelectorAll('.vyara-sb-vibe').forEach(function (el) {
    el.addEventListener('click', function () { this.classList.toggle('is-active'); });
  });

  /* ── CLEAR FILTERS ── */
  var clearBtn = document.getElementById('vyara-clear-filters');
  if (clearBtn) {
    clearBtn.addEventListener('click', function () {
      document.querySelectorAll('.vyara-sb-option').forEach(function (el) {
        el.classList.remove('is-active');
        var chk = el.querySelector('.vyara-sb-option__check');
        if (chk) chk.textContent = '';
      });
      document.querySelectorAll('.vyara-sb-vibe').forEach(function (el) {
        el.classList.remove('is-active');
      });
      if (typeof vyaraToast === 'function') vyaraToast('Filters cleared');
    });
  }

  /* ── REMOVE FILTER CHIP ── */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.vyara-chip__remove');
    if (btn) btn.closest('.vyara-chip').remove();
  });

  /* ── PRICE SLIDER (visual only) ── */
  var slider   = document.getElementById('vyara-price-slider');
  var priceVal = document.getElementById('vyara-price-val');
  if (slider && priceVal) {
    slider.addEventListener('input', function () {
      var val = parseInt(this.value);
      priceVal.textContent = '₹' + val.toLocaleString('en-IN');
      var pct = ((val - +this.min) / (+this.max - +this.min)) * 100;
      this.style.background =
        'linear-gradient(90deg, var(--vp) ' + pct + '%, var(--border) ' + pct + '%)';
    });
  }

  /* ── VIEW TOGGLE (grid / list) ── */
  var gridBtn = document.getElementById('vyara-view-grid');
  var listBtn = document.getElementById('vyara-view-list');
  var grid    = document.getElementById('vyara-product-grid');

  if (gridBtn && listBtn && grid) {
    gridBtn.addEventListener('click', function () {
      grid.classList.remove('is-list');
      gridBtn.classList.add('is-active');
      listBtn.classList.remove('is-active');
      gridBtn.setAttribute('aria-pressed', 'true');
      listBtn.setAttribute('aria-pressed', 'false');
    });
    listBtn.addEventListener('click', function () {
      grid.classList.add('is-list');
      listBtn.classList.add('is-active');
      gridBtn.classList.remove('is-active');
      listBtn.setAttribute('aria-pressed', 'true');
      gridBtn.setAttribute('aria-pressed', 'false');
    });
  }

})();
